import {updateUTCDate} from '../../../common/app_common';

export function pieChartOption ()
{
    let options = {
        chart: {
            type: 'pie',
            backgroundColor: 'transparent',
            margin: [0, 0, 0, 0],
            height: 250
        },
        credits: {
            enabled: false
        },
        title: {
            text: ''
        },
        plotOptions: {
            series: {
                borderRadius: 0,
                borderWidth: 1,
                // borderColor: '#808080',
            },
            pie: {
                // shadow: true,
                // center: ['50%', '50%']
            }
        },
        tooltip: {
            formatter: function () {
                let label = `${this.key !== undefined ? this.key : null} : ${(this.y).toFixed(2)}%`;
                return label;
            }
        },
        accessibility: {
            enabled: false
        },
        series: [
            {
                name: '',
                data: [],
                size: '60%',
                innerSize: '15%',
                dataLabels: {
                    formatter: function () {
                        return this.y > 5
                            ? this.point.name
                            : null;
                    },
                    color: '#fff',
                    distance: -40,
                    style: {
                        textOutline: 0,
                        fontFamily: 'OpenSans'
                    }
                }
            },
            {
                name: '',
                data: [],
                size: '80%',
                innerSize: '60%',
                dataLabels: {
                    formatter: function () {
                        return this.y > 1
                            ? this.point.name
                            : null;
                    },
                    color: '#fff',
                    distance: -19,
                    style: {
                        textOutline: 0,
                        fontFamily: 'OpenSans'
                    }
                }
            }, 
            {
                name: '',
                data: [],
                size: '100%',
                innerSize: '81%',
                dataLabels: {
                    formatter: function () {
                        return this.y > 1
                            ? this.point.name
                            : null;
                    },
                    color: '#fff',
                    distance: -5,
                    crop: false, //textoverflow disable
                    style: {
                        textOutline: 0,
                        fontFamily: 'OpenSans'
                    }
                },
                enableMouseTracking: false
            }
        ],
    }

    return options;
}

export function areaChartOption(seriesName, max, unit)
{
    let options = {
        chart: {
            type: 'area',
            backgroundColor: 'transparent',
            margin: [15, 10, 1, 10],
        },
        plotOptions: {
            series: {
                marker: {
                    enabled: false
                },
                states: {
                    hover: {
                        enabled: false
                    }
                }
            },
        },
        credits: {
            enabled: false
        },
        title: {
            text: ''
        },
        time: {
            useUTC: false,
        },
        xAxis: {
            lineColor: '#808080',
            type: 'datetime',
        },
        yAxis: {
            title: {
                text: ''
            },
            min: 0,
            max: max,
            endOnTick: false,
            gridLineWidth: 0,
            labels: {
                enabled: false
            },
            plotLines: [
                {
                    value: null,
                    width: 1,
                    color: '#f00',
                    zIndex: 5,
                    label: {
                        formatter: function(){
                            if(this.options.value !== null){
                                return this.options.value + unit;
                            };
                        },
                        style: {
                            color: '#fff',
                            fontSize: 11
                        },
                        x: 0
                    },
                },
            ],
        },
        tooltip: {
            valueDecimals: 2,
            valueSuffix: unit,
            xDateFormat: '%Y-%m-%d %H:%M:%S',
        },
        legend: {
            enabled: false
        },
        accessibility: {
            enabled: false
        },
        series: [
            {
                name: seriesName,
                data: [],
                color: '#5a8dee'
            },
        ],
    }

    return options;
}

export function stlChartOption()
{
    let options = {
        chart: {
            type: 'area',
            backgroundColor: 'transparent',
            margin: [15, 10, 1, 10]
        },
        plotOptions: {
            series: {
                marker: {
                    enabled: false
                },
                states: {
                    hover: {
                        enabled: false
                    }
                },
                animation: false
            },
        },
        credits: {
            enabled: false
        },
        title: {
            text: ''
        },
        time: {
            useUTC: false,
        },
        xAxis: {
            lineColor: '#808080',
            type: 'datetime',
        },
        yAxis: {
            title: {
                text: ''
            },
            min: 0,
            max: null,
            endOnTick: false,  //(default: true, max 값이 표시)  
            gridLineWidth: 0,
            labels: {
                enabled: false
            },
            plotLines: [
                {
                    value: null,
                    width: 1,
                    color: '#f00',
                    zIndex: 5,
                    label: {
                        formatter: function(){
                            if(this.options.value !== null){
                                return this.options.value + "Mbps";
                            };
                        },
                        style: {
                            color: '#fff',
                            fontSize: 11
                        },
                        x: 0
                    },
                },
            ],
        },
        tooltip: {
            valueDecimals: 2,
            valueSuffix: "Mbps",
            xDateFormat: '%Y-%m-%d %H:%M:%S',
        },
        legend: {
            enabled: false
        },
        accessibility: {
            enabled: false
        },
        series: [
            {
                name: 'STL with FEC',
                data: [],
                color: '#15bd79',
                fillOpacity: 0.3
            },
            {
                name: 'STL',
                data: [],
                color: '#5a8dee'
            }
        ],
    }
    return options;
}

export function muxOutputChartOption()
{
    let options = {
        chart: {
            type: 'area',
            backgroundColor: 'transparent',
            margin: [15, 10, 1, 10]
        },
        plotOptions: {
            series: {
                marker: {
                    enabled: false
                },
                states: {
                    hover: {
                        enabled: false
                    }
                }
            },
        },
        credits: {
            enabled: false
        },
        title: {
            text: ''
        },
        time: {
            useUTC: false,
        },
        xAxis: {
            lineColor: '#808080',
            type: 'datetime',
        },
        yAxis: {
            title: {
                text: ''
            },
            min: 0,
            max: null,
            endOnTick: false,
            gridLineWidth: 0,
            labels: {
                enabled: false
            }
        },
        tooltip: {
            formatter: tooltipLabel
        },
        legend: {
            enabled: false
        },
        accessibility: {
            enabled: false
        },
        series: [
            {
                name: 'LLS Bitrate',
                data: [],
                color: '#15bd79'
            },
            {
                name: 'Service Bitrate',
                data: [],
                color: '#5a8dee'
            }
        ],
    }

    return options;
}

function tooltipLabel()
{
    let resultStr = `<table><span style="font-size:10px">${updateUTCDate(new Date(this.x))}</span><br/>`;
    if(this.y >= 1000 && this.y < 1000000)
    {
        resultStr += `<span style='color:${this.color}'>\u25CF</span>${this.series.name} ${(this.y / 1000).toFixed(2)}Kbps`;
    }
    else if(this.y >= 1000000)
    {
        resultStr += `<span style='color:${this.color}'>\u25CF</span>${this.series.name} ${(this.y / 1000000).toFixed(2)}Mbps`;
    }
    else
    {
        resultStr += `<span style='color:${this.color}'>\u25CF</span>${this.series.name} ${(this.y).toFixed(2)}bps`;
    }
    return resultStr;
}

export function lineChartOption(seriesName, min, max, tickPosition, tickInterval, unit, margin, dash )
{
    let options = {
        chart: {
            type: 'line',
            backgroundColor: 'transparent',
            margin: margin
        },
        plotOptions: {
            series: {
                marker: {
                    enabled: false
                },
                states: {
                    hover: {
                        enabled: false
                    }
                },
                animation: false
            },
        },
        credits: {
            enabled: false
        },
        title: {
            text: ''
        },
        time: {
            useUTC: false,
        },
        xAxis: {
            visible: false,
            type: 'datetime',
            minPadding: 0,
        },
        yAxis: {
            title: {
                text: ''
            },
            min: min,
            max: max,
            tickPositions: tickPosition,
            tickInterval: tickInterval,
            gridLineWidth: 0,
            lineColor: '#fff',
            lineWidth: 1,
            labels: {
                // format: '{value}%',
                format: '',
                x: -5,
                style: {
                    color: '#fff',
                    fontSize: `${dash==='dash'?'0.6rem':11}`,
                },
            },
            plotLines: [
                {
                    value: null,
                    width: 1,
                    color: '#f00',
                    zIndex: 5,
                    label: {
                        formatter: function(){
                            if(this.options.value !== null){
                                return this.options.value + unit;
                            };
                        },
                        style: {
                            color: '#fff',
                            fontSize: 11,
                        },
                        x: 0
                    },
                },
            ],
        },
        tooltip: {
            valueDecimals: 2,
            valueSuffix: unit,
            xDateFormat: '%Y-%m-%d %H:%M:%S',
        },
        legend: {
            enabled: false
        },
        accessibility: {
            enabled: false
        },
        series: [
            {
                name: seriesName,
                data: [],
                color: '#71b9e0',
                lineWidth:1
            }
        ],
    }

    return options;
}

export function llsTsiChartOption(dataArray)
{
    let options = {
        chart: {
            type: 'line',
            backgroundColor: 'transparent',
            margin: [15, 10, 1, 10],
        },
        title: {
            text: ''
        },
        plotOptions: {
            series: {
                marker: {
                    enabled: false
                },
                states: {
                    hover: {
                        enabled: false
                    }
                },
                lineWidth: 1
            },
        },
        legend: {
            enabled: false
        },
        credits: {
            enabled: false
        },
        time: {
            useUTC: false,
        },
        xAxis: {
            lineColor: '#808080',
            type: 'datetime',
        },
        yAxis: {
            title: {
                text: ''
            },
            min: 0,
            max: null,
            endOnTick: false,
            gridLineWidth: 0,
            labels: {
                enabled: false
            },
        },
        tooltip: {
            valueDecimals: 2,
            xDateFormat: '%d/%m/%Y %H:%M:%S',
            formatter: tooltipLabel
        },
        accessibility: {
            enabled: false
        },
        series: dataArray,
    }

    return options;
}

export function barChartOption(seriesName, max, unit, margin)
{
    let options = {
        chart: {
            type: 'column',
            backgroundColor: 'transparent',
            margin: margin
        },
        colors: ['#5a71c1'],
        borderColor: '#f00',
        plotOptions: {
            series: {
                borderWidth: 0,
                pointPadding: 0,
                groupPadding: 0,
                animation: false
            },
            column: {
                minPointLength: 2,  // 값이 0 이어도 바를 표시함
                zones: [
                    {
                        value: 1, 
                        color: '#5a71c1', 
                    },
                    {
                        color: '#15bd79'
                    },
                ],
            }
        },
        credits: {
            enabled: false
        },
        title: {
            text: ''
        },
        time: {
            useUTC: false,
        },
        xAxis: {
            visible: false,
            type: 'datetime',
        },
        yAxis: {
            title: {
                text: ''
            },
            min: 0,
            max: max,
            gridLineWidth: 0,
            labels: {
                enabled: false,
                style: {
                    color: '#fff'
                }
            },
            plotLines: [
                {
                    value: null,
                    width: 1,
                    color: '#f00',
                    zIndex: 5,
                    label: {
                        formatter: function(){
                            if(this.options.value !== null){
                                return this.options.value + unit;
                            };
                        },
                        style: {
                            color: '#fff',
                            fontSize: 11,
                        },
                        x: 0
                    },
                },
                { 
                    value: 0,
                    width: 0,
                    color: '#808080'
                }
            ]
        },
        tooltip: {
            valueDecimals: 0,
            valueSuffix: unit,
            xDateFormat: '%Y-%m-%d %H:%M:%S',
        },
        legend: {
            enabled: false
        },
        accessibility: {
            enabled: false
        },
        series: [
            {
                name: seriesName,
                data: []
            }
        ],
    }

    return options;
}

export function frameTimeChartOption()
{
    let options = {
        chart: {
            type: 'bar',
            backgroundColor: 'transparent',
            marginBottom: 10
        },
        plotOptions: {
            series: {
                stacking: 'normal',
                pointPlacement: -0.1,
            },
            bar: {
                borderRadius: '0',
                borderWidth: 0,
            }
        },
        credits: {
            enabled: false
        },
        title: {
            text: ''
        },
        yAxis: {
            title: {
                enabled: false
            },
            min: 0,
            max: 400,
            gridLineWidth: 1,
            gridLineColor: '#7f849d',
            tickInterval: 50,
            labels: {
                style: {
                    color: '#7f849d',
                    fontSize: 11,
                },
                y: 10
            },
            plotLines: [
                {
                    value: 250,
                    width: 2,
                    color: '#f00',
                    zIndex: 5,
                    dashStyle: 'dash'
                },
            ],
        },
        tooltip: {
            enabled: false
        },
        legend: {
            enabled: false,
        },
        accessibility: {
            enabled: false
        },
        series: [
            {
                label: 'Subframe3',
                data: [0],
                color: "#d86195",
            },
            {
                label: 'Subframe2',
                data: [0],
                color: "#c471f5",
            },
            {
                label: 'Subframe1',
                data: [0],
                color: "#0ba360",
            },
            {
                label: 'Subframe0',
                data: [0],
                color: "#4481eb",
            },
            {
                label: 'Preamble',
                data: [4],
                color: "#ff5e00",
            },
            {
                label: 'Bootstrap',
                data: [2],
                color: "#ff0844",
            },
        ],
    }

    return options;
}

export function frameTimeChartOptionForDashBoard()
{
    let options = {
        chart: {
            type: 'bar',
            backgroundColor: 'transparent',
        },
        plotOptions: {
            series: {
                stacking: 'normal',
                pointPlacement: -0.1,
            },
            bar: {
                borderRadius: '0',
                borderWidth: 0,
            }
        },
        credits: {
            enabled: false
        },
        title: {
            text: ''
        },
        yAxis: {
            title: {
                enabled: false
            },
            min: 0,
            max: 400,
            gridLineWidth: 1,
            gridLineColor: '#7f849d',
            tickInterval: 50,
            labels: {
                style: {
                    color: '#7f849d',
                    fontSize: '0.6rem',
                },
                y: 10
            },
            plotLines: [
                {
                    value: 250,
                    width: 2,
                    color: '#f00',
                    zIndex: 5,
                    dashStyle: 'dash'
                },
            ],
        },
        tooltip: {
            enabled: false
        },
        legend: {
            enabled: false,
        },
        accessibility: {
            enabled: false
        },
        series: [
            {
                label: 'Subframe3',
                data: [0],
                color: "#d86195",
            },
            {
                label: 'Subframe2',
                data: [0],
                color: "#c471f5",
            },
            {
                label: 'Subframe1',
                data: [0],
                color: "#0ba360",
            },
            {
                label: 'Subframe0',
                data: [0],
                color: "#4481eb",
            },
            {
                label: 'Preamble',
                data: [4],
                color: "#ff5e00",
            },
            {
                label: 'Bootstrap',
                data: [2],
                color: "#ff0844",
            },
        ],
    }

    return options;
}